import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from '@progress/kendo-react-layout';
import cn from 'clsx';
import styles from '../style.module.scss';
import Tooltip from '@components-clean/core/tooltip';
import { ComparisonWidgetProps } from '@components-clean/core/widgets/widget-interfaces';
import { useTranslation } from '@hooks/index';

const WidgetItem = ({
    title,
    titleTooltip,
    datasetInFocusScore,
    comparisonDatasetScore,
    isDraggable,
    onClose,
    isActiveItem,
    comparisonDatasetSelected,
    change,
    'data-testid': testDataId,
}: ComparisonWidgetProps) => {
    const { t } = useTranslation('cm');
    const changeDirection =
        datasetInFocusScore && comparisonDatasetScore
            ? datasetInFocusScore === comparisonDatasetScore
                ? '-'
                : datasetInFocusScore > comparisonDatasetScore
                  ? 'asc'
                  : 'desc'
            : '-';

    return (
        <Tooltip position="top">
            <Card
                className={cn(
                    'widget k-border k-border-solid k-border-transparent',
                    styles.widgetCardStyling,
                    isActiveItem && styles.activeItem,
                )}
                data-testid={testDataId}
            >
                <div className={cn('k-d-flex k-align-content-center', styles.cardHeaderStyling)}>
                    <div className={cn(styles.cardTitleStyling)}>
                        {isDraggable && (
                            <FontAwesomeIcon
                                icon={['fas', 'grip-dots-vertical']}
                                className={cn('fa-lg', styles.dragIcon)}
                            />
                        )}
                        <div className={cn(styles.cardTitleTextStyling)} title={(titleTooltip || title) as string}>
                            {title}
                        </div>
                    </div>
                </div>
                <div className={cn('k-display-flex k-justify-content-start', styles.cardBody)}>
                    <div className={cn(styles.widgetIconContainer, styles.widgetContainer)}>
                        {changeDirection && (
                            <FontAwesomeIcon
                                icon={changeDirection === '-' ? ['far', 'hyphen'] : ['fass', 'triangle']}
                                className={cn({
                                    [styles.sortAscIcon]: changeDirection === 'asc',
                                    [`${styles.sortDescIcon} k-rotate-180`]: changeDirection === 'desc',
                                })}
                            />
                        )}
                    </div>
                    <div>
                        <div className={cn(styles.opraTruncate, styles.datasetInFocusStyling)}>
                            {datasetInFocusScore ?? '--'}
                        </div>
                        <div
                            className={cn(styles.opraTruncate, styles.comparisonDatasetStyling)}
                            style={{}}
                            title={
                                !comparisonDatasetScore
                                    ? comparisonDatasetSelected
                                        ? t('componentsClean.widgets.noDataToCompare')
                                        : t('componentsClean.widgets.comparisonDatasetNotSelected')
                                    : undefined
                            }
                        >
                            {comparisonDatasetScore ?? '--'}
                        </div>
                        <div className={cn(styles.opraTruncate, styles.changeField)}>{change || '--'} Change</div>
                    </div>
                </div>
                {isDraggable && (
                    <FontAwesomeIcon
                        icon={['far', 'close']}
                        className={cn(styles.closeIcon)}
                        onClick={(event) => {
                            event.stopPropagation();
                            onClose();
                        }}
                        data-testid={`${testDataId}-close`}
                    />
                )}
            </Card>
        </Tooltip>
    );
};

export default WidgetItem;
